<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>テンプレート</h2>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<h3>パラグラフ</h3>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit nesciunt nihil, sunt illo soluta voluptates consectetur, dolorem minima exercitationem quas provident ipsum aliquam dolor deserunt sed laudantium ipsa cupiditate vel.
				</p>
				<hr>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit nesciunt nihil, sunt illo soluta voluptates consectetur, dolorem minima exercitationem quas provident ipsum aliquam dolor deserunt sed laudantium ipsa cupiditate vel.
				</p>
			</div>
			<div class="e-section">
				<div class="e-grid -triple">
					<div class="col">
						<h3>リスト</h3>
						<ul>
							<li>Foo</li>
							<li>Bar</li>
							<li>Baz</li>
						</ul>
					</div>
					<div class="col">
						<h3>数字リスト</h3>
						<ol>
							<li>Foo</li>
							<li>Bar</li>
							<li>Baz</li>
						</ol>
					</div>
					<div class="col">
						<h3>定義リスト</h3>
						<dl>
							<dt>title</dt>
							<dd>content content content</dd>
							<dt>title</dt>
							<dd>content content content</dd>
						</dl>
					</div>
				</div>
			</div>
			<div class="e-section">
				<h3>ボタン</h3>
				<button class="e-button">Button</button>
				<button class="e-button -primary">Primary Button</button>
				<button class="e-button -link">Link Button</button>
			</div>
			<div class="e-section">
				<h3>インプット</h3>
				<div class="e-grid -double">
					<div class="col">
						<p>
							<input type="text" class="e-input-text" placeholder="testinput">
						</p>
						<p>
							<input type="text" class="e-input-text -full" placeholder="testinput">
						</p>
						<div class="e-label-list">
							<label v-for="i in testCount" class="e-label"><input type="checkbox"><span class="label">check</span></label>
						</div>
						<div class="e-label-list">
							<label v-for="i in testCount" class="e-label"><input type="radio"><span class="label">check</span></label>
						</div>
					</div>
					<div class="col">
						<textarea name="" id="" cols="30" rows="10" class="e-input-text -full" placeholder="textarea"></textarea>
					</div>
				</div>
			</div>
			<div class="e-section">
				<div class="e-grid -double">
					<div class="col">
					</div>
					<div class="col">
					</div>
				</div>
			</div>
			<div class="e-section">
				<h3>アイコン</h3>
				<div class="icon-list">
					<span v-for="icon in icons">
						<c-icon :name="icon" :feature="'-small'"></c-icon>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";

export default {
	mixins: [
		mCommon
	],
	data(){
		return {
			testCount: 3,
			icons: [
				"chevron-down",
				"cross",
				"error",
				"question-circle"
			]
		}
	}
}
	
</script>


<style type="less">

.icon-list {
	list-style-type: none;
	display: flex;
	padding: 0;
}

.icon-list span {
	margin-right: 1em;
}


.icon-list .e-icon {
	width: 3rem;
	height: 3rem;
}
	
</style>



// WEBPACK FOOTER //
// template.vue?31617cb1